import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/layout/Layout";
import { ReducedMotionProvider } from "./components/common/ReducedMotionController";

const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const Spaces = lazy(() => import("./pages/Spaces/Spaces"));
const Events = lazy(() => import("./pages/Events/Events"));
const Gallery = lazy(() => import("./pages/Gallery/Gallery"));
const PlanEvent = lazy(() => import("./pages/PlanEvent/PlanEvent"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}

function RouteLoader() {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--color-muted)",
        fontFamily: "var(--font-body)",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        fontSize: "0.85rem",
      }}
      role="status"
      aria-live="polite"
    >
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <ReducedMotionProvider>
        <BrowserRouter>
          <ScrollToTop />

          <Layout>
            <Suspense fallback={<RouteLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/spaces" element={<Spaces />} />
                <Route path="/events" element={<Events />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/plan-your-event" element={<PlanEvent />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
        </BrowserRouter>
      </ReducedMotionProvider>
    </HelmetProvider>
  );
}
